const initScrollTitles = () => {

    const titles = document.querySelectorAll( '.js-scroll-title' );

    if ( ! titles.length ) {
        return;
    }

    const clamp = ( value, min, max ) => {
        return Math.min( Math.max( value, min ), max );
    };

    const splitTitle = ( title ) => {

        if ( title.dataset.initialized ) {
            return;
        }

        title.dataset.initialized = 'true';

        const text = title.textContent.trim();
        const words = text.split( /\s+/ );

        title.setAttribute( 'aria-label', text );
        title.innerHTML = '';

        let charIndex = 0;

        words.forEach( ( word, wordIndex ) => {

            const wordElement = document.createElement( 'span' );

            wordElement.className = 'page-title__word';
            wordElement.setAttribute( 'aria-hidden', 'true' );

            [ ...word ].forEach( ( char ) => {

                const wrap = document.createElement( 'span' );
                const inner = document.createElement( 'span' );

                wrap.className = 'page-title__char-wrap';
                inner.className = 'page-title__char';

                inner.textContent = char;
                inner.dataset.index = charIndex;

                wrap.appendChild( inner );
                wordElement.appendChild( wrap );

                charIndex++;

            } );

            title.appendChild( wordElement );

            if ( wordIndex < words.length - 1 ) {

                const space = document.createElement( 'span' );

                space.className = 'page-title__space';
                space.setAttribute( 'aria-hidden', 'true' );
                space.innerHTML = '&nbsp;';

                title.appendChild( space );

            }

        } );

    };

    const animateTitle = ( title ) => {

        const header = title.closest( '.page-header' );

        if ( ! header ) {
            return;
        }

        const chars = title.querySelectorAll( '.page-title__char' );
        const headerRect = header.getBoundingClientRect();
        const headerHeight = header.offsetHeight;

        /*
         * Al cargar la página:
         * headerRect.top = 0
         * progress = 0
         *
         * Cuando el header ha salido completamente:
         * headerRect.top = -headerHeight
         * progress = 1
         */
        const progress = clamp(
            -headerRect.top / headerHeight,
            0,
            1
        );

        /*
         * Desplazamiento basado en el tamaño real de la tipografía.
         * Así se adapta automáticamente a móvil y escritorio.
         */
        const fontSize = parseFloat(
            window.getComputedStyle( title ).fontSize
        );

        const maxOffset = fontSize * 0.85;
        const offset = maxOffset * progress;

        chars.forEach( ( char, index ) => {

            const direction = index % 2 === 0 ? -1 : 1;

            const x = direction * offset;
            const y = direction * offset;

            char.style.transform = `translate3d(${ x }px, ${ y }px, 0)`;

        } );

    };

    const animateAll = () => {
        titles.forEach( animateTitle );
    };

    titles.forEach( splitTitle );

    let ticking = false;

    const requestAnimation = () => {

        if ( ticking ) {
            return;
        }

        ticking = true;

        requestAnimationFrame( () => {
            animateAll();
            ticking = false;
        } );

    };

    animateAll();

    window.addEventListener( 'scroll', requestAnimation, {
        passive: true,
    } );

    window.addEventListener( 'resize', requestAnimation );

};

const initFilters = () => {
    const filters = document.querySelector( '.projects-filters' );
    const emptyMessage = document.querySelector( '.projects-grid__empty' );

	if ( ! filters ) {
		return;
	}

	const toggle = filters.querySelector( '.projects-filters__toggle' );
	const panel = filters.querySelector( '.projects-filters__panel' );
	const buttons = Array.from( filters.querySelectorAll( '.projects-filters__item' ) );
	const projects = Array.from( document.querySelectorAll( '.projects-grid__item' ) );

	const activeFilters = {
		year: [],
		project_type: [],
	};

	toggle.addEventListener( 'click', () => {
		panel.hidden = ! panel.hidden;
	} );

	buttons.forEach( ( button ) => {
		button.addEventListener( 'click', () => {
			const taxonomy = button.dataset.filter;
			const termId = button.dataset.termId;

			button.classList.toggle( 'is-active' );

			if ( activeFilters[ taxonomy ].includes( termId ) ) {
				activeFilters[ taxonomy ] = activeFilters[ taxonomy ].filter( ( id ) => id !== termId );
			} else {
				activeFilters[ taxonomy ].push( termId );
			}

			filterProjects();
		} );
	} );

    function filterProjects() {
        projects.forEach( ( project ) => {
            const projectYears = project.dataset.year ? project.dataset.year.split( ',' ) : [];
            const projectTypes = project.dataset.projectType ? project.dataset.projectType.split( ',' ) : [];

            const matchesYear =
                activeFilters.year.length === 0 ||
                activeFilters.year.some( ( id ) => projectYears.includes( id ) );

            const matchesProjectType =
                activeFilters.project_type.length === 0 ||
                activeFilters.project_type.some( ( id ) => projectTypes.includes( id ) );

            project.hidden = ! ( matchesYear && matchesProjectType );
        } );

        const visibleProjects = projects.filter( ( project ) => ! project.hidden );

        if ( emptyMessage ) {
            emptyMessage.hidden = visibleProjects.length > 0;
        }
    }
}

const initMenuMobile = () => {

    const HAMBURGUER_ICON   = document.querySelector('.site-header .open-mobile')
    const NAV_CONTAINER     = document.querySelector( '.mobile-nav-container')

    if( !HAMBURGUER_ICON ) {
        return
    }

    HAMBURGUER_ICON.addEventListener( 'click', (e) => {
        e.target.classList.toggle('open')
        NAV_CONTAINER.classList.toggle( 'open' )
    })

}

document.addEventListener( 'DOMContentLoaded', initMenuMobile );
document.addEventListener( 'DOMContentLoaded', initScrollTitles );
document.addEventListener( 'DOMContentLoaded', initFilters );
